import { useMutation } from "@tanstack/react-query";
import { useRootAPI } from "@/api";
import { customToast } from "@/utils/customToast";

export function useResendInvitation() {
  const api = useRootAPI();

  return useMutation({
    mutationFn: async ({ userId, userIsDemo }: { userId: string; userIsDemo?: boolean }) => {
      if (userIsDemo) {
        return;
      }
      return api.postInviteFoodicsAccounts({ InviteFoodicsUsersRequest: { ids: [userId] } });
    },
    onSuccess: () => {
      customToast("Login instructions sent", "success", "bottom");
    },
  });
}
